// Screen `blueprints` — design/screens/Blueprints.dc.html — owner: S9.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BlueprintsPage, type BlueprintsTab } from '../../../../features/blueprints/BlueprintsPage';

const Search = z.object({ tab: z.enum(['all', 'installed', 'library', 'team']).optional().catch(undefined) });

export const Route = createFileRoute('/_settings/settings/blueprints/')({
  validateSearch: (s) => Search.parse(s),
  component: BlueprintsRoute,
});

function BlueprintsRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <BlueprintsPage
      tab={tab ?? 'all'}
      onTab={(next: BlueprintsTab) =>
        void navigate({ search: next === 'all' ? {} : { tab: next }, replace: true })
      }
    />
  );
}
